// svg4everybody();

let hasTouchScreen = false;
if ('maxTouchPoints' in navigator) {
  hasTouchScreen = navigator.maxTouchPoints > 0;
} else if ('msMaxTouchPoints' in navigator) {
  hasTouchScreen = navigator.msMaxTouchPoints > 0;
} else {
  const mQ = window.matchMedia && matchMedia('(pointer:coarse)');
  if (mQ && mQ.media === '(pointer:coarse)') {
    hasTouchScreen = !!mQ.matches;
  } else if ('orientation' in window) {
    hasTouchScreen = true; // deprecated, but good fallback
  } else {
    // Only as a last resort, fall back to user agent sniffing
    const UA = navigator.userAgent;
    hasTouchScreen =
      /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
      /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
  }
}
let replaceClassName = 'js';
replaceClassName += hasTouchScreen ? ' touch' : ' no-touch';
replaceClassName += Array.from(
  window.getComputedStyle(document.documentElement)
).some((propertyName) => propertyName.indexOf('-moz-') === 0)
  ? ' firefox'
  : ' no-firefox';
// replaceClassName += window.ApplePaySession ? ' safari' : '';
// replaceClassName +=
//     /iPad|iPhone|iPod/.test(navigator.userAgent) &&
//     !window.MSStream &&
//     (!!window.indexedDB ||
//         !!window.SpeechSynthesisUtterance ||
//         !!window.webkitAudioContext ||
//         !!window.matchMedia ||
//         (!!window.history && 'pushState' in window.history))
//         ? ' ios'
//         : '';
document.documentElement.className = document.documentElement.className.replace(
  /\bno-js\b/g,
  replaceClassName
);
document.addEventListener('DOMContentLoaded', () => {
  document.documentElement.className =
    document.documentElement.className.replace(/\bno-domready\b/g, 'domready');
});

function resize() {
  document.documentElement.style.setProperty(
    '--w-vh',
    // window.innerHeight * 0.01 + 'px'
    Math.min(
      document.documentElement.clientHeight,
      window.screen.height,
      window.innerHeight
    ) *
      0.01 +
      'px'
  );
}
resize();
window.addEventListener('resize', resize);
